export default "__VITE_ASSET__y7$$zRuK__"